import { DATETIME_FORMATS, DateUtils } from '@/common/utils';

export const DatesBetween = ({ date1, date2, gapDays }: { date1: string; date2: string; gapDays: number }) => (
  <>
    {DateUtils.formatDate(date1, DATETIME_FORMATS.MMMddyyyy)} &rarr;{' '}
    {DateUtils.formatDate(date2, DATETIME_FORMATS.MMMddyyyy)} ({gapDays} days)
  </>
);
